import { useCurrentAgencyUser } from './current-user';

/** True when the Statsig `cara_outbound_calls_enabled` gate is on for this user/org. */
export const useOutboundCallsEnabled = (): boolean => {
  return useCurrentAgencyUser().outboundCallsEnabled;
};
